import { env } from '@/utils/env';
import type { CapsuleArchiveItem } from '../../types';

export interface CapsuleArchiveAdJumpProperties {
  pits_jump_content: string;
  pits_jump_type: string;
}

export function getCapsuleStyleVenueId(index: number): string {
  return `capsule-style-venue-${index}`;
}

export function buildCapsuleArchiveAdJumpProperties(
  item: CapsuleArchiveItem,
): CapsuleArchiveAdJumpProperties {
  const urlPrefix = item.url_prefix?.trim() || '';
  const url = item.url?.trim() || '';
  const isAbsoluteUrl = /^(https?:)?\/\//i.test(url);
  const isAbsolutePrefix = /^(https?:)?\/\//i.test(urlPrefix);
  let jumpContent = '';

  if (isAbsoluteUrl) {
    jumpContent = url;
  } else if (isAbsolutePrefix) {
    jumpContent = url ? `${urlPrefix.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}` : urlPrefix;
  } else {
    const normalizedPrefix = urlPrefix ? `/${urlPrefix.replace(/^\/+|\/+$/g, '')}` : '';
    const normalizedUrl = url ? `/${url.replace(/^\/+/, '')}` : '';
    const urlAlreadyContainsPrefix = Boolean(
      normalizedPrefix &&
        (normalizedUrl === normalizedPrefix || normalizedUrl.startsWith(`${normalizedPrefix}/`)),
    );

    jumpContent = urlAlreadyContainsPrefix
      ? normalizedUrl
      : normalizedPrefix && normalizedUrl
        ? `${normalizedPrefix}${normalizedUrl}`
        : normalizedPrefix || normalizedUrl;
  }

  return {
    pits_jump_type: jumpContent ? (/^(https?:)?\/\//i.test(jumpContent) ? '4' : '3') : '',
    pits_jump_content: jumpContent,
  };
}

export function resolveCapsuleAssetUrl(path?: string): string {
  const normalizedPath = path?.trim();

  if (!normalizedPath) return '';
  if (/^(https?:)?\/\//.test(normalizedPath)) return normalizedPath;

  return `${env.NEXT_PUBLIC_S3_URL}${normalizedPath}`;
}
